<template>
    <div>
        <IndexNews :list="newsList" :logoUrl="news1"></IndexNews>
        <IndexNews :list="bulletList" :logoUrl="news2"></IndexNews>
        <div class="middle-pic" style="margin-top:60px;">
            <img src="@/../static/middle.png"/>
        </div>
        <div class="index-line"></div>
        <div class="logo-block">
            <div v-for="item in bannerTypes" v-bind:key="item.typeId" v-if="item.typeCode != '0' && item.typeCode != '6' && item.typeCode != '7' && item.typeCode != '8'">
                <Logos :mode="1" :title='item.typeName' :typeCode='item.typeCode'></Logos>
            </div>
            
        </div>
    </div>
</template>

<script>
import Entry from "../components/Entry"
import IndexNews from "../components/IndexNews"
import Logos from "../components/Logos"

export default {
    name:"Content",
    components:{
        Entry, IndexNews, Logos
    },
    data(){
        return {
            newsList:[],
            bulletList:[],
            foot:[],
            news1:'',
            news2:'',
            bannerTypes:[],
        }
    },
    mounted(){
        // this.getBanners();
        this.getNews();
        this.getBullet();
        
        this.getFooter();
        this.getColumnInfo1();
        this.getColumnInfo2();
        this.getBannerTypes();
    },
    methods:{
        getBannerTypes(){
            const self = this;
            this.$http.get("/bicycle/inter/bannerTypes").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerTypes = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
     
        getColumnInfo1(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=CLNEWS").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.news1 = res.data.data.imageUrl;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getColumnInfo2(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=CLBULLET").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.news2 = res.data.data.imageUrl;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getNews(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo=1&pageSize=4&columnId=CLNEWS&isTop=true").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.newsList = res.data.data.content;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        getBullet(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo=1&pageSize=4&columnId=CLBULLET&isTop=true").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bulletList = res.data.data.content;
                }
            }).catch(function(error){
                console.log(error);
            });
        },
      
        getFooter(){
            const self = this;
            this.$http.get("/bicycle/inter/footer").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.foot = res.data.data;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Content.vue